import type { UpcomingClass } from '../types/content';

/** SAMPLE DATA — to be replaced by the live booking calendar feed. */
export const upcomingClasses: UpcomingClass[] = [
  { id: 'c1', courseSlug: 'multi-state-ccw', date: '2026-10-24', time: '9:00am – 6:00pm', seatsLeft: 3, capacity: 20 },
  { id: 'c2', courseSlug: 'nv-ccw-renewal', date: '2026-10-25', time: '9:00am – 1:00pm', seatsLeft: 8, capacity: 20 },
  { id: 'c3', courseSlug: 'itdh', date: '2026-10-25', time: '2:00pm – 6:00pm', seatsLeft: 5, capacity: 12 },
  { id: 'c4', courseSlug: 'womens-ccw', date: '2026-10-27', time: '9:00am – 6:00pm', seatsLeft: 2, capacity: 16 },
  { id: 'c5', courseSlug: 'focc', date: '2026-10-28', time: '1:00pm – 5:00pm', seatsLeft: 6, capacity: 12 },
  { id: 'c6', courseSlug: 'multi-state-ccw', date: '2026-10-31', time: '9:00am – 6:00pm', seatsLeft: 11, capacity: 20 },
  { id: 'c7', courseSlug: 'fohd', date: '2026-11-01', time: '9:00am – 1:00pm', seatsLeft: 4, capacity: 12 },
  { id: 'c8', courseSlug: 'low-light', date: '2026-11-03', time: '5:30pm – 9:30pm', seatsLeft: 7, capacity: 10 },
  { id: 'c9', courseSlug: 'ids', date: '2026-11-07', time: '8:00am – 5:00pm', seatsLeft: 9, capacity: 14 },
  { id: 'c10', courseSlug: 'nv-ccw-renewal', date: '2026-11-08', time: '9:00am – 1:00pm', seatsLeft: 14, capacity: 20 },
];
